/**
 * Contact Widget - Floating contact button functionality
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactWidget);
  } else {
    initContactWidget();
  }

  function initContactWidget() {
    const widget = document.getElementById('contactWidget');
    if (!widget) return;

    // Show widget with animation after 1.2 seconds
    setTimeout(() => {
      widget.classList.add('active');
    }, 1200);

    // Auto-open widget after 15 seconds
    setTimeout(() => {
      widget.classList.add('show');
    }, 15000);

    // Toggle options when clicking the toggle buttons
    const toggleButtons = widget.querySelectorAll('.JSToggleOptions');
    toggleButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        widget.classList.toggle('show');
      });
    });

    // Track phone clicks (optional analytics)
    const phoneButton = widget.querySelector('.JS_triggerPhone');
    if (phoneButton) {
      phoneButton.addEventListener('click', () => {
        console.log('Contact widget: Phone clicked');
        // Add your analytics tracking here if needed
        // Example: gtag('event', 'click', { event_category: 'contact', event_label: 'phone' });
      });
    }

    // Track WhatsApp clicks (optional analytics)
    const whatsappButton = widget.querySelector('.JS_triggerWhatsapp');
    if (whatsappButton) {
      whatsappButton.addEventListener('click', () => {
        console.log('Contact widget: WhatsApp clicked');
        // Add your analytics tracking here if needed
        // Example: gtag('event', 'click', { event_category: 'contact', event_label: 'whatsapp' });
      });
    }
  }
})();
